import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Suggestion from "../../entity/assignment/Suggestion";

const SERVICE = "service-assignment";
const ENTITY = "suggestions";

export default function () {
    const {findOneBy, findAllBy, create, update} = useApi();
    const state = useSelector;
    const newInstance = data => new Suggestion(data);

    return {
        findOneByToken(token) {
            return {
                select() {
                    const result = state(state => state.api?.assignment?.[ENTITY]?.find(s => s?.getToken() === token));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findOneBy(SERVICE, ENTITY, "token", token, newInstance, "application_v7");
                }
            }
        },
        async update(id, property, payload) {
            return update(SERVICE, ENTITY, id, property, payload, newInstance, "application_v7");
        }
    }
}